import { shallowRef } from 'vue'
import type { IChat } from '@/modules/chat-matrix-fast/types/IChat'
import { hasLastMessagePreview, isEventChatItem } from '@/modules/chat-matrix-fast/constants/chat'
import { isPersistedChatListPreviewEmpty } from '@/modules/chat-matrix-fast/utils/chatListPreviewPersistence'

const pendingIds = new Set<string>()
const settledEmptyIds = new Set<string>()

export const chatListPreviewRevision = shallowRef(0)

function bumpPreviewRevision(): void {
  chatListPreviewRevision.value += 1
}

export function markChatListPreviewPending(chatId: number | string): void {
  const key = String(chatId)
  const wasPending = pendingIds.has(key)
  settledEmptyIds.delete(key)
  pendingIds.add(key)
  if (!wasPending) {
    bumpPreviewRevision()
  }
}

export function settleChatListPreviewReady(chatId: number | string): void {
  const key = String(chatId)
  const changed = pendingIds.delete(key) || settledEmptyIds.delete(key)
  if (changed) {
    bumpPreviewRevision()
  }
}

export function settleChatListPreviewEmpty(chatId: number | string): void {
  const key = String(chatId)
  const changed = pendingIds.delete(key) || !settledEmptyIds.has(key)
  settledEmptyIds.add(key)
  if (changed) {
    bumpPreviewRevision()
  }
}

export function isChatListPreviewPending(chatId: number | string): boolean {
  void chatListPreviewRevision.value
  return pendingIds.has(String(chatId))
}

export function hasPendingChatListPreviews(): boolean {
  void chatListPreviewRevision.value
  return pendingIds.size > 0
}

/** Помечает чаты текущей вкладки без last_message как «ещё грузится». Уже settled empty не трогаем. */
export function syncChatListPreviewPending(chats: IChat[], isEventsTab: boolean): void {
  let changed = false

  for (const chat of chats) {
    const matchesTab = isEventsTab ? isEventChatItem(chat) : !isEventChatItem(chat)
    if (!matchesTab) {
      continue
    }

    const key = String(chat.id)
    if (hasLastMessagePreview(chat.last_message)) {
      if (pendingIds.delete(key) || settledEmptyIds.delete(key)) {
        changed = true
      }
      continue
    }

    if (!chat.matrix_room_id?.trim()) {
      if (pendingIds.delete(key)) {
        changed = true
      }
      continue
    }

    if (settledEmptyIds.has(key) || isPersistedChatListPreviewEmpty(chat.id)) {
      if (pendingIds.delete(key) || !settledEmptyIds.has(key)) {
        settledEmptyIds.add(key)
        changed = true
      }
      continue
    }

    if (pendingIds.has(key)) {
      continue
    }

    pendingIds.add(key)
    changed = true
  }

  if (changed) {
    bumpPreviewRevision()
  }
}
